import React from 'react';
import { getBoxStyle, getTitleStyle, getTextStyle } from './ExtendedFooterBoxStyles';

interface ExtendedFooterBoxProps {
  bottomText?: boolean;
  children?: any;
  color?: string;
  link?: React.ReactNode;
  mainContent: React.ReactNode;
  oblique?: boolean;
  padding?: string;
  squareBorder?: boolean;
  title: React.ReactNode;
}

export const ExtendedFooterBox: React.FC<ExtendedFooterBoxProps> = ({
  bottomText,
  children,
  color,
  link,
  oblique,
  padding,
  squareBorder,
  mainContent,
  title,
}) => {
  const boxStyle = getBoxStyle(squareBorder, padding);
  const titleStyle = getTitleStyle(color);
  const textStyle = getTextStyle();

  return (
    <>
      <div className={`extended-footer-box ${boxStyle.className}`}>
        <span className={`extended-footer-title ${titleStyle.className}`}>{title}</span>
        <span
          className={`extended-footer-text ${textStyle.className}`}
          style={{ fontStyle: oblique ? 'oblique' : 'normal' }}
        >
          {mainContent}
        </span>
        {bottomText && (
          <span className={`extended-footer-text ${textStyle.className} bottom`}>
            Read more{' '}
            <span className="extended-footer-text" style={{ textDecoration: 'underline' }}>
              {link}
            </span>
            .
          </span>
        )}
        {children}
      </div>
      {boxStyle.styles}
      {titleStyle.styles}
      {textStyle.styles}
    </>
  );
};
